'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaQuery = exports.media = exports.boolStyle = exports.getStyle = exports.lightenColor = exports.darkenColor = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _templateObject = _taggedTemplateLiteral(['\n    @media (max-width: 1024px) {\n      ', '\n    }\n  '], ['\n    @media (max-width: 1024px) {\n      ', '\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media (min-width: 1025px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1025px) {\n      ', '\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    @media (max-width: 680px) {\n      ', '\n    }\n  '], ['\n    @media (max-width: 680px) {\n      ', '\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    @media (min-width: 1400px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1400px) {\n      ', '\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    @media (min-width: 681px) and (max-width:1024px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 681px) and (max-width:1024px) {\n      ', '\n    }\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    @media (max-width: 320px) {\n      ', '\n    }\n  '], ['\n    @media (max-width: 320px) {\n      ', '\n    }\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['', ''], ['', '']);

var _styledComponents = require('styled-components');

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var darkenColor = exports.darkenColor = function darkenColor(color) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  return (0, _tinycolor2.default)(color).darken(amount).toString();
};

var lightenColor = exports.lightenColor = function lightenColor(color) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  return (0, _tinycolor2.default)(color).lighten(amount).toString();
};

var getStyle = exports.getStyle = function getStyle(map, fallback) {
  return function (props) {
    var keysFromProps = Object.keys(map).filter(function (key) {
      return props[key] !== undefined;
    });
    var keyFromProps = keysFromProps[0];
    if (map[keyFromProps]) {
      return map[keyFromProps];
    }
    if (fallback) {
      if (props[fallback] && map[props[fallback]]) {
        return map[props[fallback]];
      }
    }
    return undefined;
  };
};

var boolStyle = exports.boolStyle = function boolStyle(key, value) {
  return function (props) {
    return props[key] ? value : null;
  };
};

var media = exports.media = {
  mobileTablet: function mobileTablet() {
    return (0, _styledComponents.css)(_templateObject, _styledComponents.css.apply(undefined, arguments));
  },
  desktop: function desktop() {
    return (0, _styledComponents.css)(_templateObject2, _styledComponents.css.apply(undefined, arguments));
  },
  mobile: function mobile() {
    return (0, _styledComponents.css)(_templateObject3, _styledComponents.css.apply(undefined, arguments));
  },
  screen: function screen() {
    return (0, _styledComponents.css)(_templateObject4, _styledComponents.css.apply(undefined, arguments));
  },
  tablet: function tablet() {
    return (0, _styledComponents.css)(_templateObject5, _styledComponents.css.apply(undefined, arguments));
  },
  extraSmallMobile: function extraSmallMobile() {
    return (0, _styledComponents.css)(_templateObject6, _styledComponents.css.apply(undefined, arguments));
  }
};

var getObjectValue = function getObjectValue(props, property, value, theme, unit) {
  if (theme && props.theme[theme]) {
    return '' + (props.theme[theme][value] || value) + unit + ';';
  }
  return '' + value + unit + ';';

  // if (property === 'font-size') {
  //   return `${props.theme.size[value] || value}px`;
  // }
  //
  // if (property === 'color') {
  //   return props.theme.color[value];
  // }
  //
  // return value;
};

// props, property: 'font-size', value: '2||14', unit: 'px', theme: 'size'

var mediaQuery = exports.mediaQuery = function mediaQuery(props, property, value) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var unit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
    return property + ': ' + getObjectValue(props, property, value, theme, unit);
  }

  return Object.keys(value).map(function (breakpoint) {
    var cssContent = property + ': ' + getObjectValue(props, property, value[breakpoint], theme, unit);
    if (breakpoint === 'default') {
      return cssContent;
    }
    return media[breakpoint](_templateObject7, cssContent);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/helpers/index.js
// module id = 68
// module chunks = 4